import debounce from "lodash.debounce";
import isMobile from "is-mobile";
export const updateViewportUnits = () => {
    const root = document.documentElement;
    if (isMobile()) {
        root.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
        root.style.setProperty("--vw", `${window.innerWidth * 0.01}px`);
    }
    else {
        root.style.setProperty("--vh", `${667 * 0.01}px`);
        root.style.setProperty("--vw", `${375 * 0.01}px`);
    }
};
export const onResize = (callback) => window.addEventListener("resize", debounce(callback, 300));
export const randomUnique = (range, count) => {
    const getRand = () => Math.floor(Math.random() * (15 - 1 + 1));
    if (count === 1) {
        return [getRand()];
    }
    const numbers = new Set();
    while (numbers.size < count) {
        numbers.add(getRand());
    }
    return Array.from(numbers);
};
export const shuffleArray = (currentArray = []) => {
    let currentIndex = currentArray.length;
    let randomIndex = 0;
    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // eslint-disable-next-line no-param-reassign
        [currentArray[currentIndex], currentArray[randomIndex]] = [
            currentArray[randomIndex], currentArray[currentIndex]
        ];
    }
    return currentArray;
};
export const getRandomNumber = (max, min) => Math.random() * (max - min) + min;
export const checkIsDesktop = () => {
    const detectionClassName = "is-full-screen";
    const detectionMobClassName = "is-mobile";
    if (isMobile()) {
        document.body.classList.remove(detectionClassName);
        document.body.classList.add(detectionMobClassName);
    }
    else {
        document.body.classList.remove(detectionMobClassName);
        document.body.classList.add(detectionClassName);
    }
};
